import { AppConfig } from "./app-config.interface";

export const app1Config: AppConfig = {
  appHasMembership: true,
  maxTicketsPerUser: 6,
  hasSeatValidation: false,
  hasTransferTicket: true
}

export const app2Config: AppConfig = {
  appHasMembership: true,
  maxTicketsPerUser: 5,
  hasSeatValidation: false,
  hasTransferTicket: true
}

export const app3Config: AppConfig = {
  appHasMembership: false,
  maxTicketsPerUser: 5,
  hasSeatValidation: false,
  hasTransferTicket: true
} 

export const app4Config: AppConfig = {
  appHasMembership: true,
  maxTicketsPerUser: 15,
  hasSeatValidation: false,
  hasTransferTicket: true
}

export const app5Config: AppConfig = {
  appHasMembership: true,
  maxTicketsPerUser: 9,
  hasSeatValidation: false,
  hasTransferTicket: true
}

export const app6Config: AppConfig = {
  appHasMembership: false,
  maxTicketsPerUser: 6,
  hasSeatValidation: true,
  hasTransferTicket: false
}

export const allAppConfigs: { [key: string]: AppConfig } = {
  '1': app1Config,
  '2': app2Config,
  '3': app3Config,
  '4': app4Config,
  '5': app5Config,
  '6': app6Config
};